"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.ResponsiveStyleManager = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

require("core-js/modules/es6.array.sort");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

var _argumentContracts = _interopRequireDefault(require("argument-contracts"));

var _resizeObserverPolyfill = _interopRequireDefault(require("resize-observer-polyfill"));

/**
 * Breakpoint Style
 * @typedef {object} BreakpointStyle
 * @property {string} className - The class name to apply for this breakpoint
 * @property {number} minWidth - The minWidth for this style
 */
var TO_STRING_RADIX = 36;
var REGISTRATION_ID_DELIMITER = '___';

function buildId() {
  return "".concat(Date.now()).concat(REGISTRATION_ID_DELIMITER).concat(Math.random().toString(TO_STRING_RADIX));
}

function validBreakpointStyles(breakpointStyles) {
  _argumentContracts.default.assertArray(breakpointStyles, 'breakpointStyles');

  if (breakpointStyles.length === 0) {
    throw new Error('breakpointStyles must have at least one entry');
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = breakpointStyles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var entry = _step.value;

      _argumentContracts.default.assertType(entry, Object, 'entry of breakpointStyles');

      _argumentContracts.default.assertString(entry.className, 'entry.className of breakpointStyles');

      _argumentContracts.default.assertNumber(entry.minWidth, 'entry.minWidth of breakpointStyles');
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}
/**
 * @private
 */


var ResponsiveStyleManager =
/*#__PURE__*/
function () {
  function ResponsiveStyleManager() {
    (0, _classCallCheck2.default)(this, ResponsiveStyleManager);

    if (ResponsiveStyleManager.__instance) {
      return ResponsiveStyleManager.__instance;
    }

    this.__resizeObserver = new _resizeObserverPolyfill.default(this.__handleResizeEvent.bind(this));
    this.__elementBreakPointStyleMap = {};
    this.__registrations = {};
    ResponsiveStyleManager.__instance = this;
  }
  /**
   * Register element for breakpoint changes on size change
   * @private
   * @param {object} options - SEE BELOW
   * @param {Node} options.element - A DOM element to watch for changes
   * @param {BreakpointStyle[]} - A set of styles and breakpoint sizes in px
   * @returns {string} A registration id for unregistering later
   */


  (0, _createClass2.default)(ResponsiveStyleManager, [{
    key: "register",
    value: function register(_ref) {
      var element = _ref.element,
          breakpointStyles = _ref.breakpointStyles;

      _argumentContracts.default.assertType(element, Node, 'element');

      _argumentContracts.default.assertType(breakpointStyles, Object, 'breakpointStyles');

      validBreakpointStyles(breakpointStyles);

      this.__resizeObserver.observe(element);

      var registrationId = buildId();
      this.__registrations[registrationId] = {
        element: element,
        breakpointStyles: breakpointStyles
      };
      var sortedBreakpointStyles = (0, _toConsumableArray2.default)(breakpointStyles).sort(function (entryA, entryB) {
        return entryB.minWidth - entryA.minWidth;
      });
      this.__elementBreakPointStyleMap[element] = sortedBreakpointStyles;
      return registrationId;
    }
    /**
     * Unregister element for resize events
     * @private
     * @param {string} registrationId - id returned from register method
     * @returns {undefined}
     */

  }, {
    key: "unregister",
    value: function unregister(registrationId) {
      _argumentContracts.default.assertString(registrationId, 'registrationId');

      if (this.__registrations.hasOwnProperty(registrationId)) {
        this.__resizeObserver.unobserve(this.__registrations[registrationId].element);

        var element = this.__registrations[registrationId].element;
        delete this.__elementBreakPointStyleMap[element];
        delete this.__registrations[registrationId];
      }
    }
  }, {
    key: "__handleResizeEvent",
    value: function __handleResizeEvent(entries) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = entries[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var entry = _step2.value;
          var width = entry.contentRect.width;
          var breakpointStyles = this.__elementBreakPointStyleMap[entry.target];
          var styleApplied = false;
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = breakpointStyles[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var breakpointStyle = _step3.value;

              if (width >= breakpointStyle.minWidth && !styleApplied) {
                styleApplied = true;
                entry.target.classList.add(breakpointStyle.className);
              } else {
                entry.target.classList.remove(breakpointStyle.className);
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }]);
  return ResponsiveStyleManager;
}();

exports.ResponsiveStyleManager = ResponsiveStyleManager;